export default "__VITE_ASSET__Bi$rIFCI__"